import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Typography, Drawer } from 'antd';
import { toast } from 'react-toastify';
import { Btn, BtnsBox } from '../../../../../../../../common/ui/Common2';
import Modal from '../../../../../../../../common/ui/Modal/Modal';
import getTableColumns from './TableConfig';
import ReportTable from './ReportTable';
import ShowText from './ShowText';
import { useToggle } from '../../../../../../../../logic/hooks/useToggle';
import SessionResultTable from '../expand/SessionResultTable';

const expandedRowRender = (record) => (
  <SessionResultTable sessionDataId={record.id} />
);

function RequestTable(props) {
  const { pagination } = props;
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [columnsFiltersList, setColumnsFiltersList] = useState({});
  const [modalData, setModalData] = useState({});
  const [isOpen, toggleOpen] = useToggle(false);
  const [modalWndtitle, setModalWndtitle] = useState('');
  // const [downloadLink, setDownloadLink] = useState();
  // const [downloadPhotoName, setDownloadPhotoName] = useState();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState(null);

  const [exporting, setExporting] = useState(false);

  const fetchTableData = async () => {
    setLoading(true);
    // const res = await SqlQuery(pagination.startDate, pagination.endDate);

    const res = await axios.get('/api/reports/surveyReport/', {
      params: {
        token: window.localStorage.getItem('token'),
        startDate: pagination.startDate,
        endDate: pagination.endDate,
      },
    });

    console.log('res ==== ', res);

    const uniqueSource = [];
    const uniqueOperetors = [];
    const sourceList = [];
    const operatorList = [];

    res.data.data.forEach((el) => {
      if (!uniqueSource.includes(el.source)) uniqueSource.push(el.source);
      if (!uniqueOperetors.includes(el.fio)) uniqueOperetors.push(el.fio);
    });

    uniqueSource.forEach((el) => {
      sourceList.push({ text: el, value: el });
    });

    uniqueOperetors.forEach((el) => {
      operatorList.push({ text: el, value: el });
    });
    setColumnsFiltersList({ operatorList, sourceList });
    setTableData(res.data.data);
    setLoading(false);
  };

  const handleTableIcon = (name, row) => {
    // if (name === 'photo') {
    //   setModalData(
    //     <img style={{ width: '100%' }} src={row.photo_b64} alt="" />,
    //   );
    //   setModalWndtitle('Фотография посетителя');
    //   setDownloadLink(row.photo_b64);
    //   setDownloadPhotoName(`Photo-session${row.id}`);
    //   toggleOpen();
    // } else
    if (name === 'micro') {
      setModalData(
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <audio style={{ width: '100%' }} controls>
          <source src={row.audiorecordpath} />
        </audio>,
      );
      setModalWndtitle('Аудио запись');
      // setDownloadLink(row.audiorecordpath);
      toggleOpen();
    } else if (name === 'video') {
      console.log('row.videorecordpath === ', row.videorecordpath);
      setModalData(
        <video controls style={{ width: '100%' }}>
          <source src={row.videorecordpath} />
        </video>,
      );
      setModalWndtitle('Видео запись');
      // setDownloadLink(row.videorecordpath);
      toggleOpen();
    } else if (name === 'comment') {
      setDrawerData(row.extraData);
      setDrawerOpen(true);
    }
  };

  const resetModal = () => {
    toggleOpen();
  };

  const runExport = async () => {
    if (!tableData.length) {
      toast.warn('Нет данных для экспорта');
      return;
    }
    setExporting(true);
    try {
      const token = window.localStorage.getItem('token');

      // Ответы приходят из /surveyReport одним bulk-запросом (см. fetchTableData).
      // Больше НЕ дёргаем ответы веером по одной сессии — под нагрузкой хвост запросов
      // падал по таймауту и оценки молча терялись из выгрузки.
      const sessionsWithAnswers = tableData.map((session) => ({
        ...session,
        answers: Array.isArray(session.answers) ? session.answers : [],
      }));

      // Собираем уникальные вопросы (по тексту)
      const questionsMap = new Map();
      sessionsWithAnswers.forEach((s) => {
        s.answers.forEach((a) => {
          if (a.question && !questionsMap.has(a.question)) {
            questionsMap.set(a.question, `q_${questionsMap.size}`);
          }
        });
      });

      // Формируем колонки
      const exportColumns = [
        { dataIndex: 'created_on', title: 'Дата прохождения' },
        { dataIndex: 'number', title: '№ талона' },
        { dataIndex: 'fio', title: 'Оператор' },
        { dataIndex: 'source', title: 'Источник' },
        { dataIndex: 'surveyname', title: 'Название опроса' },
      ];
      questionsMap.forEach((key, questionText) => {
        exportColumns.push({ dataIndex: key, title: questionText });
      });

      // Формируем плоские строки
      const exportItems = sessionsWithAnswers.map((session) => {
        const row = {
          created_on: session.created_on,
          number: session.number,
          fio: session.fio,
          source: session.source,
          surveyname: session.surveyname || '',
        };
        session.answers.forEach((a) => {
          const colKey = questionsMap.get(a.question);
          if (colKey) {
            row[colKey] = a.answer || '';
          }
        });
        return row;
      });

      const answer = await axios({
        method: 'post',
        url: `/api/reports/?token=${token}`,
        data: {
          type: 'surveyReport',
          token,
          filters: {
            main: {
              startDate: pagination.startDate,
              endDate: pagination.endDate,
            },
          },
          items: exportItems,
          TableConfig: exportColumns,
          needToExport: true,
        },
      });
      if (answer.statusText === 'OK') {
        toast.success('Отчет подготавливается для скачивания и появится в разделе "Архив"', 1000);
      }
    } catch (err) {
      console.error('Export error:', err);
      toast.error('Ошибка при экспорте отчета');
    } finally {
      setExporting(false);
    }
  };

  useEffect(() => {
    fetchTableData();
  }, [pagination]);

  // const photoOfVisiter = modalWndtitle === 'Фотография посетителя'
  //   ? (
  //     <a href={downloadLink} download={downloadPhotoName}>
  //       <Btn valid margin="0 25px 0 0" bg="green">Сохранить</Btn>
  //     </a>
  //   )
  //   : (
  //     <a href={downloadLink} download>
  //       <Btn valid margin="0 25px 0 0" bg="green">Сохранить</Btn>
  //     </a>
  //   );

  return (
    <div>

      <Modal title={modalWndtitle} isOpen={isOpen} toggleOpen={resetModal}>
        {modalData}
        <BtnsBox>
          {modalWndtitle === 'Комментарий посетителя' ? null : null}
          <Btn cancel onClick={() => toggleOpen()} bg="accent">Закрыть</Btn>
        </BtnsBox>
      </Modal>

      <Typography.Title level={2} style={{ textAlign: 'center', color: '#25547A' }}>
        Оценка качества
      </Typography.Title>
      <div style={{
        marginBottom: 16, display: 'flex', gap: 16, alignItems: 'center',
      }}
      >
        <Button
          type="primary"
          size="large"
          onClick={runExport}
          loading={exporting}
          disabled={!tableData.length}
        >
          Экспортировать
        </Button>
      </div>

      <ReportTable
        rowKey="id"
        columns={getTableColumns(columnsFiltersList, handleTableIcon)}
        data={tableData}
        loading={loading}
        expandable={{
          expandedRowRender,
          rowExpandable: (record) => record.type === 'Опрос',
        }}
      />

      <Drawer
        title="Комментарий посетителя"
        placement="right"
        width={500}
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
      >
        <ShowText item={drawerData} />
      </Drawer>

    </div>
  );
}

export default RequestTable;
